import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {dataAttributesFromObject} from "../../lib/Helpers";

class ListItem extends Component {
    render() {

        return <React.Fragment>
            <div className="result">
                <Link to={`${this.props.path}`} onClick={this.props.onClick} {...dataAttributesFromObject(this.props.data)}>
                    {this.props.image && <div className="image" style={{backgroundImage: `url("${this.props.image}")`}}></div>}
                    <span className={`title`}>{this.props.name}</span>
                    {this.props.subTitle && <span className={`meta`}>{this.props.subTitle}</span>}
                    {this.props.description && <span className={`description`}>{this.props.description}</span>}
                </Link>
            </div>
        </React.Fragment>
    }
}

ListItem.propTypes = {
    // optional props
    image: PropTypes.string,
    date: PropTypes.string,
    subTitle: PropTypes.string,
    onClick: PropTypes.func,

    // required props
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
};

export default ListItem;
